import authService from "../../common/service/authService";
import BaseService from "../../common/service/baseService";
import { COURSES_URL, COURSES_ENROLLED } from "../utils/constants";

export default class x extends BaseService {
  /**
   * @get my courses
   * */
  async myCourses() {
    return await this.get(`${this.buildUrl(COURSES_URL)}`, {
      my: 1,
      page_size: 6,
      page: 1,
      query:
        "{id, name, user_progress, course_image, url, certificate_download_url, is_eligible_for_certificate}",
    });
  }

  /**
   * @get all courses
   * */
  async courses(level: NSCourses.CourseLevel | null, search: string) {
    const params: any = {};
    if (!!level) {
      params.level = level;
    }
    if (!!search) {
      params.search = search;
    }

    return await this.get(`${this.buildUrl(COURSES_URL)}`, { ...params });
  }

  /**
   * enroll user from course
   * @post
   * */
  async enroll(url: string, body: {}) {
    return await this.post(url, body, {
      params: { with_signup: authService.isAuthenticated ? 0 : 1 },
    });
  }

  /**
   * Get courses list for sitemap
   * */
  async coursesPaths() {
    return await this.get(`${this.buildUrl(COURSES_URL)}`, {
      query: "{slug, modified_at}",
    });
  }

  async coursesEnrolled() {
    return await this.get(`${this.buildUrl(COURSES_ENROLLED)}`);
  }
}
